module.exports = __webpack_public_path__ + "img/success-wall.1e0c38a5.png";